export const defaultGridTranslatorValue = () => {
  return {
    styles: { width: 200, height: 200 },
    text_styles: {
      font_color:"#000",
      font_size:40
    },
    modification: {
      margin_top: 0,
      margin_left: 0,
      is_horizontal_flip: false,
      is_vertical_flip: false,
      rotate_deg:0
    },
    letter:""
  };
}